// En ProjectDataTable.tsx

import React from 'react';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { ProjectDataForm, ProjectFilters } from '../../../../app/models/Project';
import ProjectSwitchChange from '../ProjectSwitchChange';

interface Props {
  projects: ProjectDataForm[];
  totalRows: number;
  loading?: boolean;
  edit?: (id: number) => void;
  show?: (id: number) => void;
  destroy?: (id: number) => void;
  filter: ProjectFilters;
  setFilter: (filter: ProjectFilters) => void;
  callbackSuccess: () => void;
}

const renderVal = (v: any) => (v === null || v === undefined || v === '' ? '-' : v);

const ProjectDataTable = ({
  projects, totalRows, loading = false, edit, show, destroy, filter, setFilter, callbackSuccess
}: Props) => {
  
  const columns = [
    {
      name: 'Id',
      selector: (row: any) => row.id,
      sortable: true,
      sortField: 'id',
      cell: (row: ProjectDataForm) => <span>{row.id}</span>
    },
    {
      name: 'Nombre',
      selector: (row: any) => row.name,
      sortable: true,
      sortField: 'name',
      cell: (row: ProjectDataForm) => <span>{renderVal(row.name)}</span>
    },
    {
      name: 'N° naves',
      selector: (row: any) => row.greenhouses_count,
      sortable: true,
      sortField: 'greenhouses_count',
      cell: (row: any) => <span>{renderVal(row.greenhouses_count)}</span>
    },
    {
      name: 'N° túneles',
      selector: (row: any) => row.corridors_count,
      sortable: true,
      sortField: 'corridors_count',
      cell: (row: any) => <span>{renderVal(row.corridors_count)}</span>
    },
    {
      name: 'Activo',
      selector: (row: any) => row?.is_active,
      sortable: true,
      sortField: 'is_active',
      minWidth: '120px',
      cell: (row: any) => (
        <ProjectSwitchChange
          projectId={row.id!}
          checkValue={row.is_active ?? true}
          callbackSuccess={callbackSuccess}
        />
      )
    },
    {
      name: 'Acciones',
      selector: (row: any) => row.id,
      sortable: false,
      cell: (row: ProjectDataForm) => (
        <div>
          {show && <ButtonTableAction callbackFunction={() => show(row.id ?? -1)} classIcon="mdi mdi-eye" colorIcon="text-info" title="Ver" />}
          {edit && <ButtonTableAction callbackFunction={() => edit(row.id ?? -1)} classIcon="mdi mdi-pencil" colorIcon="text-warning" title="Editar" />}
          {destroy && <ButtonTableAction callbackFunction={() => destroy(row.id ?? -1)} classIcon="mdi mdi-delete" colorIcon="text-danger" title="Eliminar" />}
        </div>
      )
    }
  ];

  return (
    <>
      <div className="row mt-3"><div className="col">{/* Filtros opcionales */}</div></div>
      <DefaultDataTable
        columns={columns}
        data={projects}
        progressPending={loading}
        paginationTotalRows={totalRows}
        filter={filter}
        setFilter={setFilter}
      />
    </>
  );
};

export default ProjectDataTable;